export default __webpack_public_path__ + "static/media/orange-circle.da06e8eb.svg";